<template>
  <v-layout column class="event">
    <v-flex xs12 sm12 class="primary--text event-line">
      <v-layout align-center>
        <v-avatar size="30">
          <v-icon size="20">cloud_upload</v-icon>
        </v-avatar>
        <span class="ml-2 font-weight-bold">Uploading a file ...</span>
        <span v-if="false" class="ml-2 font-weight-bold">{{event.userDisplayName}}</span>
        <span v-if="false" class="pl-2 font-weight-light">[{{userCompanyName}}] commented</span>
      </v-layout>
    </v-flex>
    <v-flex xs12 sm12 class="event-line ml-1 pl-4 pr-4 mr-1" align-center>
      {{ event.percent }}%
      <v-progress-linear class="mt-0 pt-0"
                         v-model="event.percent">
      </v-progress-linear>
    </v-flex>
  </v-layout>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'UploadProgressEvent',
  props: {
    event: {
      type: Object,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/timeline/UploadProgressEvent.vue